module.exports = __webpack_public_path__ + "assets/img/team-button-reserve-386fbd2e.png";